import { useSyncExternalStore } from 'react';
import { govEffects, govOf, type GovBanner, type GovEffects, type GovPolicyId } from '@london-life/contracts';
import { api } from './api';
import { useCatalogue } from './content';

// Gov (contracts gov.ts) on every screen: the Mayor, the policy in force and the announcement, as the map's
// banner shows them; and what the policy does to the prices and pay the screens show (the server charges and
// pays the same). Asked for when the game opens, every minute while it is open, and whenever the player's state
// says another policy is in force.

const EVERY_MS = 60_000;
let banner: GovBanner | null = null;
const listeners = new Set<() => void>();
const subscribe = (listener: () => void) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

let loading: Promise<void> | null = null;
export function loadGovBanner() {
  loading ??= api
    .govBanner()
    .then((reply) => {
      banner = reply.banner;
      listeners.forEach((listener) => listener());
    })
    .catch(() => {})
    .finally(() => {
      loading = null;
    });
  return loading;
}
// the player's state names the policy in force: the banner is asked again when it differs
export function policyFromPlay(policy: GovPolicyId | null | undefined) {
  if (policy !== undefined && (banner?.policy?.id ?? null) !== (policy ?? null)) void loadGovBanner();
}
// a reply from Gov carries the banner as it is now
export function setGovBanner(next: GovBanner) {
  banner = next;
  listeners.forEach((listener) => listener());
}

export function useGovBanner() {
  return useSyncExternalStore(subscribe, () => banner);
}
// what the policy in force does now (1 for anything it leaves alone)
export function useGovEffects(): GovEffects {
  const catalogue = useCatalogue();
  const policy = useGovBanner()?.policy?.id ?? null;
  return govEffects(govOf(catalogue ?? {}), policy);
}

if (typeof window !== 'undefined') {
  void loadGovBanner();
  window.setInterval(() => {
    if (document.visibilityState === 'visible') void loadGovBanner();
  }, EVERY_MS);
}
